import { render, staticRenderFns } from "./PutTeamOnHoldDialog.vue?vue&type=template&id=ac98845c&scoped=true&"
import script from "./PutTeamOnHoldDialog.vue?vue&type=script&lang=ts&"
export * from "./PutTeamOnHoldDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PutTeamOnHoldDialog.vue?vue&type=style&index=0&id=ac98845c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac98845c",
  null
  
)

export default component.exports